module.exports = __webpack_public_path__ + "media/images/accounts-start-choose-template-601f69ab46f9fd485a8bb04bca03fa63.svg";